import { useMemo } from 'react';

import { usePageUrl } from '../navigation/usePageURL';

import type { Thing, WithContext } from 'schema-dts';

export const useSchema = <T extends Thing>(data: T): WithContext<T> => {
  const url = usePageUrl();

  const schema = useMemo(() => {
    if (typeof data !== 'object') {
      throw new Error('Schema data must be an object');
    }

    const baseSchema = {
      '@context': 'https://schema.org',
      url,
      ...data,
    };

    return baseSchema as WithContext<T>;
  }, [url, data]);

  return schema;
};
